'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _BasePostLoginFlowStrategy = require('./BasePostLoginFlowStrategy');

var _BasePostLoginFlowStrategy2 = _interopRequireDefault(_BasePostLoginFlowStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BusinessMusicPostLoginFlowStrategy = function (_BasePostLoginFlowStr) {
  (0, _inherits3.default)(BusinessMusicPostLoginFlowStrategy, _BasePostLoginFlowStr);

  function BusinessMusicPostLoginFlowStrategy() {
    (0, _classCallCheck3.default)(this, BusinessMusicPostLoginFlowStrategy);
    return (0, _possibleConstructorReturn3.default)(this, (BusinessMusicPostLoginFlowStrategy.__proto__ || (0, _getPrototypeOf2.default)(BusinessMusicPostLoginFlowStrategy)).apply(this, arguments));
  }

  (0, _createClass3.default)(BusinessMusicPostLoginFlowStrategy, [{
    key: 'handleUserInfoResponse',
    value: function handleUserInfoResponse() {
      var auth = this.auth;
      var appInfo = this.appInfo;
      var log = this.log;
      var pushState = this.pushState;

      (0, _Login2.default)(auth.sessionId, auth, log, appInfo, pushState);
    }
  }]);
  return BusinessMusicPostLoginFlowStrategy;
}(_BasePostLoginFlowStrategy2.default);

exports.default = BusinessMusicPostLoginFlowStrategy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/login/strategy/BusinessMusicPostLoginFlowStrategy.js
// module id = 2034
// module chunks = 0